<script lang="ts">
	import {
		northAmericaCountryCodes,
		southAmericaCountryCodes,
		europeCountryCodes,
		africaCountryCodes,
		oceaniaCountryCodes,
		asiaCountryCodes
	} from '$lib/util/ecom/countries';

	import Text from '$lib/components/Text.svelte';
	import GlobalMedia from '../media/GlobalMedia.svelte';
	import { page } from '$app/stores';
	import { createEventDispatcher, onMount } from 'svelte';

	const dispatch = createEventDispatcher();

	export let open: boolean;

	$: location = $page.data.availableLocations;

	let activeContinent: any = null;

	function toggleContinent(continent: string) {
		if (activeContinent !== continent) {
			activeContinent = continent;
		} else {
			activeContinent = null;
		}
	}

	$: continents = [
		{
			name: 'africa',
			locations: location.filter((loc: any) => africaCountryCodes.includes(loc.isoCode))
		},
		{
			name: 'asia',
			locations: location.filter((loc: any) => asiaCountryCodes.includes(loc.isoCode))
		},
		{
			name: 'europe',
			locations: location.filter((loc: any) => europeCountryCodes.includes(loc.isoCode))
		},
		{
			name: 'north_america',
			locations: location.filter((loc: any) => northAmericaCountryCodes.includes(loc.isoCode))
		},
		{
			name: 'south_america',
			locations: location.filter((loc: any) => southAmericaCountryCodes.includes(loc.isoCode))
		},
		{
			name: 'oceania',
			locations: location.filter((loc: any) => oceaniaCountryCodes.includes(loc.isoCode))
		}
	];
</script>

<div
	class="location-wrapper"
	class:open
	on:click|self={() => {
		dispatch('close', null);
	}}
>
	<div class="location-bar" class:open>
		<div class="top">
			<div class="title">
				<Text key="ecom_shipping_to" />
			</div>
			<div
				class="close"
				on:click={() => {
					dispatch('close', null);
				}}
			>
				<GlobalMedia key="icon-close" />
			</div>
		</div>
		<div class="country-list">
			{#each continents as continent}
				<div
					class="continent"
					class:open={activeContinent === continent.name}
					class:empty={continent.locations.length === 0}
				>
					<div
						class="title"
						on:click={() => {
							toggleContinent(continent.name);
						}}
					>
						<Text key={'ecom_' + continent.name} />
						<div class="arrow">
							<GlobalMedia key="icon-arrow-down" />
						</div>
					</div>
					<div class="countries">
						{#if continent.locations.length === 0}
							<div class="no-locations">
								<Text key="ecom_no_locations" />
							</div>
						{/if}
						{#each continent.locations as location}
							<div
								class="country"
								class:active={location.isoCode === $page.data.location}
								on:click={() => {
									dispatch('onlocationchange', { location: location.isoCode });
								}}
							>
								<div class="name">{location.name}</div>
								<div class="currency">{location.currency.symbol}</div>
							</div>
						{/each}
					</div>
				</div>
			{/each}
		</div>
	</div>
</div>

<style lang="scss">
	.no-locations {
		width: 100%;
		text-align: center;
		font-style: italic;
	}
	.location-wrapper {
		position: fixed;
		inset: 0;
		width: 100%;
		height: 100%;
		background-color: color(modal__backdrop);
		z-index: v(z-index-cart);
		@include transition(all);
		cursor: pointer;

		&:not(.open) {
			background-color: color(modal__backdrop__hidden);
			pointer-events: none;

			.cart {
				transform: translateX(100%);
			}
		}
	}

	.location-bar {
		position: fixed;
		top: 0;
		right: 0;
		height: 100vh;
		height: 100dvh;
		transform: translateX(100%);
		width: 500px;
		max-width: 100%;
		background: color(grey_01);
		padding: v(content-padding);
		z-index: 15;
		overflow-y: auto;

		transition: all 0.3s ease;

		&.open {
			transform: translateX(0);
		}

		.top {
			width: 100%;
			display: flex;
			gap: v(content-padding);
			align-items: center;
			justify-content: space-between;
			margin-bottom: v(content-padding-lg);

			.title {
				@include font(h3);
			}

			.close {
				width: 1.75rem;
				height: 1.75rem;
				cursor: pointer;
			}
		}

		.country-list {
		}

		.continent {
			border-bottom: 1px solid #ddd;
			margin-bottom: v(content-padding);
			padding: v(content-padding-sm) 0;

			.title {
				width: 100%;
				display: flex;
				justify-content: space-between;
				gap: v(content-padding);
				align-items: center;

				@include font(h5);
			}

			.countries {
				display: none;
				margin-top: 1.5rem;
			}

			.arrow {
				width: 14px;
				height: 14px;
				display: flex;
				align-items: center;
				transition: all 0.3s ease;
			}

			&.empty {
				opacity: 0.5;
			}

			&.open {
				.arrow {
					transform: rotate(180deg);
				}

				.countries {
					display: flex;
					flex-direction: column;

					@include font(text);

					.country {
						margin-bottom: 24px;
						cursor: pointer;
						display: flex;
						width: 100%;
						gap: v(content-gap-sm);
						justify-content: space-between;

						&.active,
						&:hover {
							font-weight: 600;
						}

						&.active {
							.name {
								text-decoration: underline;
								text-underline-offset: 0.2em;
							}
						}
					}
				}
			}
		}
	}
</style>
